import { format } from "date-fns";
import { casesActions } from "configs";
import {
  generateId,
  useCurrentCase,
  useDispatch,
  useParams,
  useToast
} from "duck";
import { useCreatePostAnestheticVitalMutation } from "requests";
import { FormValues } from "./types";

export const useCreatePostAnestheticVital = (
  patientId: number,
  onSuccess: () => void
) => {
  const { id: caseId } = useParams();
  const toast = useToast();
  const dispatch = useDispatch();
  const [create] = useCreatePostAnestheticVitalMutation({
    ignoreResults: true
  });
  const shouldSync = useCurrentCase(medicalCase => medicalCase.shouldSync);

  return (values: FormValues) => {
    const variables = {
      fluidRate: values.fluidRate,
      temperature: values.temperature,
      timeMonitoring: values.timeMonitoring?.toISOString(),
      heartRate: values.heartRate,
      respiratoryRate: values.respiratoryRate,
      painScore: values.painScore,
      meanBloodPressure: values.meanBloodPressure,
      comment: values.comment,
      initials: values.initials
    };

    if (shouldSync) {
      return create({
        variables: {
          input: {
            patient: patientId,
            ...variables
          }
        }
      }).then(({ data }) => {
        const vital = data?.createPostAnestheticVital?.postAnestheticVital;
        if (vital) {
          dispatch(
            casesActions.addPostAnestheticVital({ data: vital, _id: caseId })
          );
        }

        onSuccess();
        toast({
          status: "success",
          description: `Post-Anesthetic Vitals for ${format(
            values.timeMonitoring as Date,
            "h:mm aaaa"
          )} are added successfully.`
        });
      });
    }

    dispatch(
      casesActions.addPostAnestheticVital({
        _id: caseId,
        data: {
          fakeId: generateId(),
          ...variables
        }
      })
    );
    onSuccess();
    toast({
      status: "success",
      description: `Post-Anesthetic Vitals for ${format(
        values.timeMonitoring as Date,
        "h:mm aaaa"
      )} are added successfully.`
    });
  };
};
